import {StateHttpReport} from "./state-http-report";
export interface EntityAdditional extends StateHttpReport{
    sort?: {direction?: 'asc' | 'desc', property: string};
}
export const entityInitial = (overwrite: EntityAdditional = {}): EntityAdditional => {
   return {...{isLoading: false, firstLoad: false, sort: null}, ...overwrite}
}